import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Nav, NavDropdown, MenuItem, NavItem } from "react-bootstrap";

function AdminNavbarLinks(props) {
  const getStatusColor = () => {
    let connectionCode = 0;
    if (props.signalRConnected) {
      connectionCode++;
    }
    if (props.videoConnected) {
      connectionCode++;
    }
    switch (connectionCode) {
      case 1:
        return "#bbbb0b";
      case 2:
        return "green";
      default:
        return "red";
    }
  }

  const getLocationStatusColor = () => {
    if (props.clientLocation)
      return "green";
    else
      return "red";
  }

  return (
    <div>
      <Nav pullRight>
        <NavItem>
          <FontAwesomeIcon icon="map-marked-alt" color={getLocationStatusColor()} />
        </NavItem>
        <NavDropdown
          eventKey={2}
          title={<FontAwesomeIcon icon="network-wired" color={getStatusColor()} />}
          id="basic-nav-dropdown-right"
        >
          <MenuItem eventKey={1.1} onClick={props.onSendJob}>Send Job</MenuItem>
          <MenuItem eventKey={2.1} onClick={props.onDisconnect}>Disconnect</MenuItem>
        </NavDropdown>
      </Nav>
    </div>
  );
}

export default AdminNavbarLinks;
